import { render, staticRenderFns } from "./LawDecisionForm.vue?vue&type=template&id=78cbf1ca&"
import script from "./LawDecisionForm.vue?vue&type=script&lang=js&"
export * from "./LawDecisionForm.vue?vue&type=script&lang=js&"
import style0 from "./LawDecisionForm.vue?vue&type=style&index=0&id=78cbf1ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports